import { isOnboardedForLab, isOnboardedForPharma } from '../../../pages/utils';

const OrdersBt: React.FC<{
    isSelected: boolean;
    onClick: () => void;
}> = ({ onClick, isSelected }) => {
    return isOnboardedForPharma() || isOnboardedForLab() ? (
        <div onClick={onClick} className={`menuitem ${isSelected ? 'selected' : ''}`}>
            <div>
                <div>
                    <svg
                        width="22"
                        height="22"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                        className="fill-darwin-neutral_new-800"
                    >
                        <rect width="24" height="24" rx="8" fill="none" />
                        <path
                            d="M19.5312 10.4688C21.4688 12.4375 21.4688 15.5938 19.5312 17.5625C17.5625 19.5 14.4062 19.5 12.4375 17.5625C10.5 15.5938 10.5 12.4375 12.4375 10.4688C14.4062 8.53125 17.5625 8.53125 19.5312 10.4688ZM13.0312 12.125C11.0312 15.2812 14.7188 18.9688 17.875 16.9688L13.0312 12.125ZM18.9375 15.9062C20.9688 12.75 17.25 9.0625 14.0938 11.0625L18.9375 15.9062ZM6.5 5C8.40625 5 10 6.59375 10 8.5V15.4688C10 17.375 8.40625 18.9375 6.5 18.9375C4.5625 18.9375 3 17.4062 3 15.4688V8.5C3 6.59375 4.5625 5 6.5 5ZM8.5 12V8.5C8.5 5.84375 4.5 5.84375 4.5 8.5V12H8.5Z"
                            fill="#004BA8"
                        />
                    </svg>
                </div>
                <p>Orders</p>
            </div>
            <div>
                <svg
                    width="25"
                    height="25"
                    viewBox="0 0 28 28"
                    className="fill-neutral-5 cursor-pointer"
                    preserveAspectRatio="xMidYMid meet"
                >
                    <path d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z"></path>
                </svg>
            </div>
        </div>
    ) : null;
};

export default OrdersBt;
